<template>
  <v-card
    style="position: fixed; left: 0; right: 0; top: 0; bottom: 0; z-index: 10"
  >
    <v-progress-linear
      v-show="loadingCamera"
      indeterminate
      color="primary"
      height="100%"
    ></v-progress-linear>
    <div
      v-show="setSelfie"
      class="d-flex align-center justify-center"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 3;
        margin-top: 10px;
      "
    >
      <p class="count-down" v-if="!loadingCamera && countDown == 3">3</p>
      <p class="count-down" v-if="!loadingCamera && countDown == 2">2</p>
      <p class="count-down" v-if="!loadingCamera && countDown == 1">1</p>
    </div>

    <vue-web-cam
      v-show="setSelfie"
      class="webcam"
      :class="{ 'reverse-camera': reverseCamera }"
      ref="webcam"
      :device-id="deviceId"
      height="100%"
      @started="onStarted"
      @stopped="onStopped"
      @error="onError"
      @cameras="onCameras"
      @camera-change="onCameraChange"
    />
  </v-card>
</template>
<script>
import { WebCam } from "vue-web-cam";
import { mapGetters } from "vuex";
const fb = require("../firebase.js");

export default {
  components: {
    "vue-web-cam": WebCam,
  },
  mounted() {
    this.onStart();
  },
  data: () => ({
    valid: true,
    model: null,
    menu: false,
    countDown: 4,
    loadingCamera: false,
    setSelfie: false,
    camera: null,
    deviceId: null,
    devices: [],
    imageUrl: null,
    reverseCamera: true,
    fullScreenPicture: false,
  }),
  watch: {
    camera: function (id) {
      // console.log("camera ", id);
      this.deviceId = id;
    },
    devices: function () {
      // console.log("devices ", this.devices);
      const [first, second, ...tail] = this.devices;
      if (second) {
        this.camera = second.deviceId;
        this.deviceId = second.deviceId;
        this.reverseCamera = false;
      } else if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
        this.reverseCamera = true;
      }
    },
  },
  computed: {
    ...mapGetters(["selectedMarker"]),
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    user: {
      get: function () {
        return this.$store.state.user;
      },
      set: function (newValue) {
        this.$store.commit("setUser", newValue);
      },
    },
  },
  methods: {
    setFullScreenPicture() {
      this.fullScreenPicture = true;
    },

    onCapture() {
      this.setSelfie = false;
      let image = this.$refs.webcam.capture();
      this.imageUrl = image;
      this.onStop();

      let message = {
        createdAt: fb.firebase.firestore.Timestamp.now(),
        userId: this.user.id,
      };

      if (this.user.profilePictureUrl)
        message.profilePictureUrl = this.user.profilePictureUrl;
      if (this.user.name) message.userName = this.user.name;

      this.$store.dispatch("uploadItem", {
        image: image,
        folder: "comments",
        target: "comments",
        message: message,
      });
      this.$emit("endCapture");
    },
    onStarted(stream) {
      this.loadingCamera = false;
      let self = this;
      setTimeout(function () {
        self.onCapture();
        self.countDown = "";
      }, 3000);
      setTimeout(function () {
        self.countDown = 1;
      }, 2000);
      setTimeout(function () {
        self.countDown = 2;
      }, 1000);
      this.countDown = 3;
    },
    onStopped(stream) {},
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.setSelfie = true;
      this.loadingCamera = true;
      if (this.$refs.webcam) this.$refs.webcam.start();
    },
    onError(error) {
      console.log(error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      this.onStart();
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
  },
};
</script>


<style>
/* * {
  border: solid 1px red;
} */
.reverse-camera {
  transform: scaleX(-1);
}
@keyframes countDown {
  0% {
    transform: scale(2.5);
  }
  100% {
    transform: scale(1);
  }
}
.count-down {
  font-size: 50px;
  color: white;
  animation: countDown 2s;
}

@keyframes zoominoutselfie {
  0% {
    transform: scale(1) scaleX(-1);
  }
  50% {
    transform: scale(0.9) scaleX(-1);
  }
  100% {
    transform: scale(1) scaleX(-1);
  }
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.webcam {
  object-fit: cover;
}
.v-slide-group__wrapper {
  padding-right: 20px;
}

.fullScreenPicture {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadein 0.2s;
  transform-origin: 50% 50%;
  background-color: transparent !important;
  backdrop-filter: blur(6px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
